<!--
// app/components/Shared/players/MvpChip.vue
-->
<script setup lang="ts">
import type { SeasonStatsPartner } from "~~/src/season-cluster/domain/models/01.Season";

type Props = {
  total: number | string;
  mvpPartner?: SeasonStatsPartner;
  isTurnMvp?: boolean;
};

defineProps<Props>();

const { $t } = useI18n();
</script>

<template>
  <div class="container-mvp-info">
    <div class="stats-data-container-mvp">
      <img v-if="mvpPartner" :src="mvpPartner.logo" :alt="mvpPartner.name" class="h-4" />
      <span class="text-secondary text-xs">{{
        isTurnMvp ? $t("players.card.turnMvp.title") : $t("players.card.mvp.title")
      }}</span>
      <span class="font-bold">{{ total }}</span>
    </div>
  </div>
</template>

<style scoped>
.stats-data-container-mvp {
  @apply rounded-lg bg-gray-800 flex items-center justify-start gap-2 max-w-max px-2 py-1;
}
</style>
